import { Helpers } from '../../helpers';
import { IResourceLevelingPreference } from '../../interfaces/iresource-leveling-preference';
import { ResourceLevelingSetting } from '../resource-leveling-setting';

export class ResourceLevelingPreferenceBase {
  ResourceLevelingPreferenceId: number;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ResourceLevelingSettings_LevelingPreference?: Array<ResourceLevelingSetting> | null;

  constructor(item?: IResourceLevelingPreference) {
    if (item) {

      this.ResourceLevelingPreferenceId = item.ResourceLevelingPreferenceId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ResourceLevelingSettings_LevelingPreference = Helpers.createClassArray(ResourceLevelingSetting, item.ResourceLevelingSettings_LevelingPreference);
    }
  }
}